import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../../../components/Layout"
import Header from "../../../components/Header"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import ThumbnailImage from "../../../images/thumbnails/jsconf.png"

export function Index() {
  return (
    <Layout
      title="JSConf India Community Engagement with AI Photo Sharing – Premagic Case Study"
      description="Discover how JSConf India enhanced developer community engagement, real-time event networking, and attendee experience using AI-powered photo distribution by Premagic."
      keywords={[
        "JSConf case study, JavaScript conference photos, developer event networking, tech conference AI, JS community engagement, developer meetup photos, coding conference technology, tech event photo sharing, JavaScript developer events, conference photo automation, developer community building, tech meetup solutions, programming conference tools, JS conference management, developer event platform, attendee experience",
      ]}
      metaImage={ThumbnailImage}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "JSConf India", url: "/case-study/jsconf/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "JSConf India Community Engagement with AI Photo Sharing - Premagic Case Study",
            "description": "Discover how JSConf India enhanced developer community engagement, real-time event networking, and attendee experience using AI-powered photo distribution by Premagic.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-01-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.JSCONF} />
    </Layout>
  )
}

export default Index
